import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M2.5,-0.5h1.5v0.5h-1.5zM1,0h3v0.5h-3zM-3.5,0.5h2v0.5h-2zM1.5,0.5h2v0.5h-2zM-1.5,1h3v0.5h-3z',
    },
    {
      paint: 'moss',
      d: 'M-3,-1.5h1.5v0.5h-1.5zM1,-1.5h1v0.5h-1zM-3.5,-1h2v0.5h-2zM1,-1h2.5v0.5h-2.5zM-3.5,-0.5h1.5v0.5h-1.5zM1,-0.5h1.5v0.5h-1.5zM-4,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1,-8.5h1.5v1h-1.5zM-1,-7.5h1v0.5h-1zM-1.5,-7h0.5v0.5h-0.5zM-4.5,-6.5h1v0.5h-1zM-3,-6.5h1.5v0.5h-1.5zM-3.5,-6h1.5v0.5h-1.5zM2,-6h1.5v0.5h-1.5zM-3,-5.5h0.5v2h-0.5zM1.5,-5.5h1.5v0.5h-1.5zM0,-5h3v0.5h-3zM-0.5,-4.5h3.5v0.5h-3.5zM-0.5,-4h2.5v0.5h-2.5zM-2.5,-3.5h1v0.5h-1zM0,-3.5h0.5v0.5h-0.5zM-2,-3h0.5v0.5h-0.5zM-2,-2.5h1v0.5h-1zM-1.5,-2h0.5v0.5h-0.5zM-1.5,-1.5h1v1h-1zM0.5,-1.5h0.5v2h-0.5zM-2,-0.5h1.5v0.5h-1.5zM-2.5,0h1.5v0.5h-1.5zM-1.5,0.5h3v0.5h-3z',
    },
    {
      paint: 'bareBranch',
      d: 'M-1,-7h0.5v0.5h-0.5zM-1.5,-6.5h0.5v0.5h-0.5zM-2,-6h1v0.5h-1zM-2.5,-5.5h1v0.5h-1zM-2.5,-5h1.5v0.5h-1.5zM-2.5,-4.5h2v1h-2zM-1.5,-3.5h1.5v0.5h-1.5zM-1.5,-3h2v0.5h-2zM-1,-2.5h1.5v0.5h-1.5zM-1,-2h2v0.5h-2zM-0.5,-1.5h1v1.5h-1zM-1,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'bushDark',
      d: 'M-1,-10.5h1.5v0.5h-1.5zM-2.5,-10h0.5v1h-0.5zM0,-10h1v0.5h-1zM0.5,-9.5h0.5v0.5h-0.5zM-3.5,-9h4.5v0.5h-4.5zM-4.5,-8.5h1.5v0.5h-1.5zM-2,-8.5h0.5v0.5h-0.5zM2,-8.5h2v0.5h-2zM-5,-8h0.5v0.5h-0.5zM-1.5,-8h0.5v0.5h-0.5zM1,-8h0.5v0.5h-0.5zM4,-8h1v0.5h-1zM-5.5,-7.5h0.5v0.5h-0.5zM-2,-7.5h1v0.5h-1zM0.5,-7.5h0.5v0.5h-0.5zM4.5,-7.5h0.5v0.5h-0.5zM-5.5,-7h4v0.5h-4zM0.5,-7h1.5v0.5h-1.5zM3.5,-7h2v0.5h-2zM-3.5,-6.5h0.5v0.5h-0.5zM1,-6.5h3.5v0.5h-3.5z',
    },
    {
      paint: 'epicJade',
      d: 'M-2,-10h0.5v0.5h-0.5zM-0.5,-10h0.5v0.5h-0.5zM-2,-9.5h2.5v0.5h-2.5zM-3,-8.5h1v0.5h-1zM-4.5,-8h3v0.5h-3zM1.5,-8h0.5v0.5h-0.5zM3,-8h1v0.5h-1zM-5,-7.5h3v0.5h-3zM1,-7.5h3.5v0.5h-3.5zM2,-7h1.5v0.5h-1.5zM-4,-0.5h0.5v0.5h-0.5z',
    },
    { paint: 'leafLight', d: 'M-1.5,-10h1v0.5h-1zM2,-8h1v0.5h-1z' },
  ],
  pixels: 255,
};
export const sprites: readonly PixelSprite[] = [variant0];
